<template>
<div class="basic_crumbs_index"
v-if="$store.state.app.view_pattern === 'pc'"
  @mouseenter="module_isHover(true)"
  @mouseleave="module_isHover(false)">
    <div class="tooptipPart">
      <template v-if="$store.state.app.view_pattern === 'pc'" class="module_edit_btn">
        <my_edit_btn :module="module" :title="$t('widgets_basic_button_index_451')"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index" :title="$t('widgets_basic_button_index_453')"></my_close_btn>
      </template>
    </div>
    <div class="basic_crumbs_content" v-loading="loading">
      <ul class="basic_crumbs_list">
        <span class="normal" :style="{
            '--fontSize': fontSize,
          }"> {{ getLang($t('widgets_basic_crumbs_index_491')) }}：</span>
        <li v-for="(item,index) in crumbsList" :key="index">
          <router-link
            :to="{ path: item.link, query: item.link === '/search' ? $route.query : {} }"
            :target="_self"
            :title="item.title"
            :style="{
              '--fontStyle': fontStyle,
              '--textDecoration': textDecoration,
              '--fontSize': fontSize,
              '--fontWeight': fontWeight,
              '--fontColor': fontColor,
              '--seFontColor': seFontColor,
              '--fontFamily': fontFamily,
              '--backgroundImage': backgroundImage,
              '--seBackgroundImage': seBackgroundImage
            }"
            :class="Number(index) === Number(crumbsList.length - 1) ? 'in_actived actived' : 'in_actived'"
          >{{ item.name }}
          <i class="normal" :style="{
            '--fontSize': fontSize,
          }">{{ Number(index) !== Number(crumbsList.length - 1) ? Number(listArr.moduleStyle) === 1 ? '/' : '>' : ''}}</i>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

  import { getCrumbs } from "@/api/app";
export default {
  name: "basic_crumbs_index",
  data() {
    return {
      loading: false,
      isHover: false,
      crumbsList: []
    }
  },
 props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
 },
 computed:{
   widgets_infor () {
     return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
   },
   pc_widgets_infor () {
     return this.module.data.pc_widgets_infor
   },
   listArr () {
     return this.module.data.listArr
   },
   fontStyle() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     return font.fontStyle;
   },
   textDecoration() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     return font.textDecoration;
   },
   fontWeight() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     return font.fontWeight;
   },
   fontSize() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     return font.fontSize  + 'px';
   },
   fontColor() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     let color = font.pattern === 'pure_color' ? font.color : 'transparent'
     return color
   },
   seFontColor() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     let color = font.sePattern === 'pure_color' ? font.selectColor : 'transparent'
     return color
   },
   fontFamily() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     return font.fontFamily
   },
   backgroundImage() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     const background = font.pattern === 'pure_color' ? '' : `linear-gradient(${font.linear_gradient.deg}deg, ${font.linear_gradient.start_color} ${font.linear_gradient.start_pointer}%, ${font.linear_gradient.end_color} ${font.linear_gradient.end_pointer}%)`
     return background
   },
   seBackgroundImage() {
     const widgets_infor = this.module.data.pc_widgets_infor
     let font = widgets_infor.font[widgets_infor.font.radio_val]
     const background = font.sePattern === 'pure_color' ? '' : `linear-gradient(${font.seLinear_gradient.deg}deg, ${font.seLinear_gradient.start_color} ${font.seLinear_gradient.start_pointer}%, ${font.seLinear_gradient.end_color} ${font.seLinear_gradient.end_pointer}%)`
     return background
   },
   needCrumbs(){
     let excludeList = ['user_register','user_index','user_index','user_index','user_forget']
     return !excludeList.includes(this.$route.name)
   }
 },
 methods: {
   module_isHover(val) {
     this.isHover = val;
   },
   getCrumbsList() {
     this.loading = true;
     let routeName = this.$route.name
     let data = {
       page: routeName
     }
     if(routeName.indexOf('product') > -1) {
       if(this.$route.query.id !== undefined) {
         data.id = this.$route.query.id
       }
     } else if(routeName.indexOf('article') > -1 || routeName.indexOf('case') > -1 || routeName.indexOf('help') > -1 || routeName.indexOf('video') > -1) {
       if(this.$route.query.typeId !== undefined || this.$route.query.id !== undefined) {
         data.id = this.$route.query.typeId !== undefined ? this.$route.query.typeId : this.$route.query.id
       }
     }
     console.log(66,data)
     getCrumbs(data).then(res => {
         if (res.code == 200 && res.data && res.data instanceof Array) {
           let len = res.data.length
           res.data.forEach((item,index)=> {
             let link = ''
             if(item.module == 'index:index') { //首页
               link = '/index'
              } else if(item.module == 'video:index' || item.module == 'article:index' || item.module == 'case:index' || item.module == 'help:index' || item.module == 'download:index') {
               link = '/' + item.module.split(':').join('_')               
             } else if(item.url.indexOf('product') > -1) { //产品
               if(item.url.indexOf('item') > -1) {
                  link = 'product?id=' + item.id
               } else if(item.url === '/product.html') {
                 link = 'product_index'
               } else {
                 link = 'product_index?id=' + item.id + '&name=' + item.title
               }
             } else if(item.url.indexOf('article') > -1 || item.url.indexOf('help') > -1 || item.url.indexOf('case') > -1 || item.url.indexOf('video') > -1) {//文章、案例、帮助、视频
               if(item.url === '/article.html' || item.url === '/help.html' || item.url === '/case.html' || item.url === '/video.html') {
                 link = item.url.replace('.html','') + '_index'
               } else if(item.url.indexOf('item') > -1) {
                 let type = item.url.substr(0,item.url.indexOf('-'))
                 link = type + '?id=' + item.id
               } else {
                 let type = item.url.substr(0,item.url.indexOf('-'))
                 link = type + '_index?typeId=' + item.id + '&name=' + item.title
               }
             } else if(item.url.indexOf('about') > -1) { //关于我们
               link = '/about'
             } else if(item.url.indexOf('message') > -1) { //在线留言
               link = '/message'
             } else if(item.url.indexOf('contact') > -1) { //联系我们
               link = '/contact'
             } else if(item.url.indexOf('culture') > -1) { //企业文化
               link = '/culture'
             } else {
               link = item.url.replace('.html','')
             }
             item.link = link
             //中文站
             if(this.$store.state.app.language == 'zh-cn') {
               if(item.title.length > 10) {
                 if(index === len - 1 && item.title.length > 15) {
                   item.name = item.title.substr(0, 15) + '...'
                 } else {
                   item.name = item.title.substr(0, 10) + '...'
                 }
               } else {
                  item.name = item.title
               }
             } else {//外文站
               if(item.title.length > 20) {
                 if(index === len - 1 && item.title.length > 30) {
                   item.name = item.title.substr(0, 30) + '...'
                 } else {
                   item.name = item.title.substr(0, 20) + '...'
                 }
               } else {
                  item.name = item.title
               }
             }
           })
           console.log(77,res.data)
           this.crumbsList = res.data
         } else {
           this.$message.error({
             showClose: true,
             message: res.message
           });
         }
       }).catch((res) => {
         this.$message.error({
           showClose: true,
           message: res.message
         });
       }).finally(() => {
         this.loading = false;
       });
   }
 },
 created(){
 },
 mounted(){
   if(this.needCrumbs){
     this.getCrumbsList()
   }
 },
  components: {
  }
}
</script>

<style lang="scss" scoped>
  .basic_crumbs_list {
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .in_actived{
    font-style: var(--fontStyle);
    text-decoration: var(--textDecoration);
    font-size: var(--fontSize);
    color: var(--fontColor);
    font-weight: var(--fontWeight);
    font-family: var(--fontFamily);
    background-image: var(--backgroundImage);
    -webkit-background-clip: text;
    white-space: nowrap;
  }
  .actived {
    color: var(--seFontColor) !important;
    background-image: var(--seBackgroundImage) !important;
  }
  .normal {
    color: #333333;
    cursor: pointer;
    font-size: var(--fontSize);
    font-weight: 500;
    padding-right: 5px;
    white-space: nowrap;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/basic_crumbs/index.vue